import React from "react";
import { Input } from "./Input";

interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onClear: () => void;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
}) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <label className="body-text text-sm text-gray-600 whitespace-nowrap">
          From:
        </label>
        <Input
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          className="w-40"
        />
      </div>
      <div className="flex items-center gap-2">
        <label className="body-text text-sm text-gray-600 whitespace-nowrap">
          To:
        </label>
        <Input
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          className="w-40"
        />
      </div>
      {(startDate || endDate) && (
        <button
          onClick={onClear}
          className="px-3 py-2 text-sm text-gray-600 hover:text-blazerex-green transition-colors"
        >
          Clear
        </button>
      )}
    </div>
  );
};

